import { connect } from 'react-redux';
import { useCallback, useEffect } from 'react';
import ExecutionEnvironment from 'exenv';

import { HYDRA_PERSONALIZATION_MARKER } from 'constants/hydraTests';
import { trackEvent } from 'helpers/analytics';
import { makePersonalizationMarker } from 'helpers/PersonalizationUtils';
import { getAssignmentGroup, triggerAssignment } from 'actions/ab';
import MelodyCarousel from 'components/common/MelodyCarousel';
import MelodyCardCategory from 'components/common/melodyCard/MelodyCardCategory';
import PersonalizationMarker from 'components/landing/PersonalizationMarker';

import css from 'styles/components/landing/melodyPersonalizedCategories.scss';

export const MelodyPersonalizedCategories = ({ firstName, slotName, slotDetails, slotIndex, onLandingComponentClick, shouldLazyLoad, location, isCustomer, hydraPersonalizationMarker }) => {
  const { categories, monetateId } = slotDetails;
  const handleClick = useCallback(e => {
    trackEvent('TE_PERSONALIZED_CATEGORIES_CLICK', `slotIndex:${slotIndex}`);
    onLandingComponentClick(e);
  }, [onLandingComponentClick, slotIndex]);

  useEffect(() => {
    trackEvent('TE_PERSONALIZED_CATEGORIES_VIEW', `slotIndex:${slotIndex}`);
  }, [slotIndex]);

  if (categories?.length) {
    return (
      <div className={css.wrap} data-slot-id={slotName} data-monetate-id={monetateId}>
        <h2 className={css.heading}>
          {Boolean(firstName) && `${firstName}, `}You Might Like These Categories.
          {makePersonalizationMarker({
            PersonalizationMarker,
            isCustomerRecognized: isCustomer,
            isPersonalized: true,
            componentName: 'MelodyPersonalizedCategories',
            sourcePage: 'LANDING_PAGE',
            location
          }, hydraPersonalizationMarker)}
        </h2>
        <MelodyCarousel>
          {categories.map(category => {
            const { product: { styleId } } = category;
            return <MelodyCardCategory
              cardData={category}
              onLandingComponentClick={handleClick}
              key={styleId}
              eventLabel="melodyPersonalizedCategories"
              melodyCardTestId="melodyPersonalizedCategories"
              shouldLazyLoad={shouldLazyLoad} />;
          })}
        </MelodyCarousel>
      </div>
    );
  } else {
    return null;
  }
};

function mapStateToProps(state) {
  const location = ExecutionEnvironment.canUseDOM ? window.location : state.routing.locationBeforeTransitions || {};
  return {
    firstName: state.holmes?.firstName,
    isCustomer: !!state.cookies['x-main'],
    hydraPersonalizationMarker: getAssignmentGroup(HYDRA_PERSONALIZATION_MARKER, state),
    triggerAssignment,
    location
  };
}

export default connect(mapStateToProps, {
})(MelodyPersonalizedCategories);
